import React from 'react';
import { Routes, Route } from "react-router-dom";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

// Routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import {AuthProtected} from './AuthProtected';

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                {/* Public Routes */}
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                        key={idx}
                    />
                ))}

                {/* Auth Protected Routes */}
                {authProtectedRoutes.map((route, idx) => (
                    <Route
                        key={idx}
                        path={route.path}
                        element={
                            <AuthProtected allowedTypes={route.allowedTypes}>
                                <VerticalLayout>{route.component}</VerticalLayout>
                            </AuthProtected>
                        }
                    />
                ))}
            </Routes>
        </React.Fragment>
    );
};

export default Index;
